import React, { useEffect, useState } from 'react'
import { FaSearch, FaBuilding } from 'react-icons/fa'
import { FaArrowRightLong } from 'react-icons/fa6'
import { Link } from 'react-router-dom'
import GlobalSearch from '../components/GlobalSearch'
import secureLocalStorage from 'react-secure-storage'
import axios from 'axios'


const Skeleton = ({ number }) => {
    return (
        [...Array(number)].map((_, index) => (
            <div className='col-lg-4 col-md-6 col-12'>
                <div class="skeleton-card">
                    <div class="skeletonasd avatar-skeleton"></div>
                    <div class="skeletonasd text-skeleton short"></div>
                    <div class="skeletonasd text-skeleton medium"></div>
                    <div class="skeletonasd text-skeleton full"></div>
                    <div class="skeletonasd text-skeleton full"></div>
                    <div class="skeletonasd btn-skeleton"></div>
                </div>
            </div>
        ))
    );
};



function UserGroups({ userId, type = 'group' }) {
    const auth = JSON.parse(secureLocalStorage.getItem('auth_data'));
    const [groups, setGroup] = useState(null);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [memberCounts, setMemberCounts] = useState({});

    const fetchMemberCounts = async (groupsData) => {
        if (!groupsData?.length) return;
        groupsData.forEach(group => {
            axios.get(`https://buzzinguniverse.com/backend/api/groups/all-members?group_id=${group.id}&page=1`)
                .then(res => {
                    setMemberCounts(prev => ({ ...prev, [group.id]: res.data?.data?.total || 0 }));
                })
                .catch(() => {});
        });
    };

    const fetchGroup = async (page, e) => {
        setLoading(true);
        e && e.preventDefault();
        try {
            const res = await axios.get(`https://buzzinguniverse.com/backend/api/groups/getByUser?user_id=${userId}&search=${search}&page=${page}&type=${type}`);
            setGroup(res.data?.data || null);
            setCurrentPage(res.data?.data.current_page);
            setLastPage(res.data?.data.last_page);
            fetchMemberCounts(res.data?.data?.data);
        } catch (err) {
            console.error("Failed to fetch group:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGroup(currentPage);
    }, [currentPage]);

    const handlePageChange = (page) => {
        if (page !== currentPage && page >= 1 && page <= lastPage) {
            setCurrentPage(page);
        }
    };

    const renderPagination = () => {
        if (lastPage <= 1) return null;

        const pages = [];
        for (let i = 1; i <= lastPage; i++) {
            pages.push(
                <li key={i} className={i === currentPage ? "active" : ""}>
                    <button onClick={() => handlePageChange(i)}>{i}</button>
                </li>
            );
        }

        return <ul className="pagination">{pages}</ul>;
    };


    return (
        <div className="col-lg-10 col-12" id='pills-tabContent'>
            <div className="inner-groups-box">
                <div className="all-groups">
                    <ul>
                        <li><p style={{textTransform: "capitalize"}}>{type}</p></li>
                        <li><span>{groups?.total}</span></li>
                    </ul>
                </div>
                <div className="search-groups-row">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="search-groups-box">
                                <form onSubmit={(e) => fetchGroup(1, e)}>
                                    <input type="text" onChange={(e) => setSearch(e.target.value)} placeholder={`Search ${type === 'company' ? 'Companies' : 'Groups'}...`} />
                                    <div className="search-groups-box-icon">
                                        <button type="submit"><FaSearch /></button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="search-groups-boxs-row">
                    <div className="row">
                        {loading ? (
                            <Skeleton number={6} />
                        ) : (
                            groups?.data?.length > 0 ? (
                                groups.data.map((group) => (
                                    <div className="col-lg-4 col-md-6 col-12" key={group.id}>
                                        <div className="search-groups-boxs">
                                            <div className="search-groups-box-back" style={{
                                                backgroundImage: `url("https://buzzinguniverse.com/backend/${encodeURI(group.cover_photo)}"), radial-gradient(circle, rgb(153 153 153) 0%, rgba(0, 0, 0, 0.15) 58%, rgba(0, 0, 0, 0.3) 100%)`
                                            }} />
                                            <span>
                                                {group.profile_picture ? (
                                                    <img
                                                        src={`https://buzzinguniverse.com/backend/${group.profile_picture}`}
                                                        alt={group.name}
                                                    />
                                                ) : group.type === 'company' ? (
                                                    <div className="company-icon-placeholder">
                                                        <FaBuilding />
                                                    </div>
                                                ) : (
                                                    <img
                                                        src="/images/mystery-group.png"
                                                        alt={group.name}
                                                    />
                                                )}
                                            </span>
                                            <h2><Link to={`/company/${group.id}/${group.name.replace(/\s+/g, '-').toLowerCase()}`}>{group.name}</Link></h2>
                                            <strong>Active 6 hours ago</strong>
                                            <div className='adminslist-adf'>
                                                {group.admins && group.admins.map((admin, key) => (
                                                    key < 10 && (
                                                        <Link to={`/member/${admin.user.id}/profile`} key={admin.user.id}>
                                                            <img
                                                                src={admin.user.photo
                                                                    ? `https://buzzinguniverse.com/backend/${admin.user.photo}`
                                                                    : "/images/default.png"}
                                                                alt={admin.user.first_name}
                                                            />
                                                        </Link>
                                                    )
                                                ))}
                                            </div>
                                            <h4>{group.privacy ? group.privacy.charAt(0).toUpperCase() + group.privacy.slice(1) : ''} {group.type === 'company' ? 'Company' : 'Group'} 
                                            <br></br><br></br> {memberCounts[group.id] ?? '...'} <br></br> {group.type === 'company' ? (memberCounts[group.id] === 1 ? 'follower' : 'followers') : (memberCounts[group.id] === 1 ? 'member' : 'members')}</h4>
                                            <div className="search-groups-btn">
                                                {group.url
                                                    ? <a href={group.url} target="_blank" rel="noopener noreferrer">View {type === 'company' ? 'Company' : 'Group'}</a>
                                                    : <Link to={`/company/${group.id}/${group.name.replace(/\s+/g, '-').toLowerCase()}`}>View {type === 'company' ? 'Company' : 'Group'}</Link>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div classname="col-12 text-center py-4">
                                    <div className="sorry-activity-found p-4" style={{ width: '75%' }}><ul className="m-0"><li><i className="fas fa-info" /></li><li><p>No {type === 'company' ? 'companies' : 'groups'} found.</p></li></ul></div>
                                </div>

                            )
                        )}

                    </div>
                </div>
            </div>
            <div className="search-groups-pages-number mt-4 d-flex justify-content-center">
                {renderPagination()}
            </div>
        </div>
    )
}

export default UserGroups
